<div class="components-list"
  cdkDropList
  cdkDropListHasAnchor
  cdkDropListSortingDisabled
  [cdkDropListConnectedTo]="getConnectedLists()"
  [cdkDropListData]="componentsItems"
  id='sidebar'
>
  @for (item of components; track item.type) {
    <mat-card class="component-card" cdkDrag [cdkDragData]="item.defaultItem"> 
      <mat-card-header>
        <mat-card-title>{{ item.inputs?.label || 'No label' }}</mat-card-title>
      </mat-card-header>
      <mat-icon>toggle_on</mat-icon>
    </mat-card>
  }
</div>
